import { makeStyles } from "@material-ui/core";

import {
  BODY1_FONT_SIZE,
  BODY1_FONT_WEIGHT,
  BODY1_LINE_HEIGHT,
  FONT_FAMILY,
  VALIDATE_BUTTON_BG,
  VALIDATE_BUTTON_BG_PRESSED,
} from "./utils/style.const";
export default class StyleConfig {
  public paymentDetails = () => {
    return makeStyles({
      RadioCheckButtonColor: {
        color: VALIDATE_BUTTON_BG,
        "&:hover": {
          color: VALIDATE_BUTTON_BG_PRESSED,
        },
        "&$checked": {
          color: VALIDATE_BUTTON_BG_PRESSED,
        },
      },
      input: {
        fontFamily: FONT_FAMILY,
      },
      label: {
        fontFamily: FONT_FAMILY,
        fontSize: BODY1_FONT_SIZE,
        fontWeight: BODY1_FONT_WEIGHT,
        lineHeight: BODY1_LINE_HEIGHT,
      },
    })();
  };
}
